<template>
    <a-card :bordered="false" :loading="loading" v-if="loading"> Loading </a-card>
    <div class="m-position-relative" v-else>
      <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
        <template v-if="id === null || id === undefined">
          <a-card class="m-wrong">
            <m-anim
              :options="notfound"
              class="anim"
              :height="getScreen ? 200 : 500"
              :width="getScreen ? 200 : 500"
            ></m-anim>
            <h3>Not Found</h3>
            <label
              >Return to the previous page and make the selection manifest
              again!</label
            >
            <a-button type="primary" block>
              <router-link :to="{ name: 'proyekrab' }">
                <a-icon type="rollback" />&nbsp; Return
              </router-link>
            </a-button>
          </a-card>
        </template>
        <template v-else>
          <a-row :gutter="14">
            <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
              <a-card class="margin-bottom" :loading="loading">
                <div slot="title">Budget Manifest</div>
                <a-popover
                  slot="extra"
                  trigger="click"
                  :placement="getScreen ? 'left' : 'bottom'"
                >
                  <span slot="title">Select Option</span>
                  <ul class="m-list-wrapper bordered" slot="content">
                    <li v-if="data2.status_besar=='Revised' && getAuth.username==data2.header[0].penyusun_anggaran">
                      <a-button
                        block
                        class="width-full"
                        @click="handleEdit(data2.anggaran_id)"
                        type="danger"
                        icon="edit"
                      >Edit</a-button>
                    </li>
                    <li>
                      <a-button
                        v-if="data2.draft"
                        type="primary"
                        icon="clock-circle"
                        class="width-full"
                        @click="visibleDraftHistory=!visibleDraftHistory"
                      >History Budget</a-button>
                    </li>
                    <li>
                      <a-button
                        block
                        slot="content"
                        icon="download"
                        type="primary"
                        @click="btnExport"
                        :disabled="data2.status_besar !== 'Approved'"
                      >
                        Download Excel
                      </a-button>
                      <a-button
                        v-if="data2.header[0].sts_close!='1' && isFc"
                        type="danger"
                        icon="close-square"
                        class="width-full margin-top"
                        :loading="loading_close"
                        @click="handleCloseTrans()"
                      >Close</a-button>
                    </li>
                  </ul>
                  <a-button :size="getScreen ? 'small' : 'default'" icon="more">{{
                    !getScreen ? "Option" : ""
                  }}</a-button>
                </a-popover>
  
                <div v-if="data2.header" class="m-card-body" id="headerId">
                  <ul class="m-list-wrapper bordered">
                    <li>
                      <span class="m-list-title" for>Budget Type</span>
                      <span class="m-list-desc">{{
                        data2.header[0].jenis_anggaran
                          ? "(" +
                            data2.header[0].jns_anggaran_id +
                            ") " +
                            data2.header[0].jenis_anggaran
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Cost Center Code</span>
                      <span class="m-list-desc">{{
                        data2.header[0].kode_cost_center
                          ? data2.header[0].kode_cost_center
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Job Name</span>
                      <span class="m-list-desc">{{
                        data2.header[0].nama_pekerjaan
                          ? data2.header[0].nama_pekerjaan
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Compiler</span>
                      <span class="m-list-desc">{{
                        data2.header[0].penyusun_anggaran
                          ? data2.header[0].penyusun_anggaran
                          : "-"
                      }}</span>
                    </li>
                    <li
                      v-if="
                        'kuasa_anggaran_ga' in data2.header[0] === false &&
                        'kuasa_anggaran_marketing' in data2.header[0] === false &&
                        'kuasa_anggaran_operasi' in data2.header[0] === false
                      "
                    >
                      <span class="m-list-title" for>Budget Authority</span>
                      <span class="m-list-desc"
                        >{{ data2.header[0].kuasa_anggaran }}
                      </span>
                    </li>
                    <li v-if="'kuasa_anggaran_ga' in data2.header[0]">
                      <span class="m-list-title" for>Budget GA Authority</span>
                      <span class="m-list-desc">{{
                        data2.header[0].kuasa_anggaran_ga
                          ? data2.header[0].kuasa_anggaran_ga
                          : "-"
                      }}</span>
                    </li>
                    <li v-if="'kuasa_anggaran_marketing' in data2.header[0]">
                      <span class="m-list-title" for
                        >Budget Marketing/IBD</span
                      >
                      <span class="m-list-desc">{{
                        data2.header[0].kuasa_anggaran_marketing
                          ? data2.header[0].kuasa_anggaran_marketing
                          : "-"
                      }}</span>
                    </li>
                    <li v-if="'kuasa_anggaran_operasi' in data2.header[0]">
                      <span class="m-list-title" for
                        >Budget Operation Authority</span
                      >
                      <span class="m-list-desc">{{
                        data2.header[0].kuasa_anggaran_operasi
                          ? data2.header[0].kuasa_anggaran_operasi
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Fiscal Year</span>
                      <span class="m-list-desc">{{
                        data2.header[0].tahun_anggaran
                          ? data2.header[0].tahun_anggaran
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Revision Number</span>
                      <span class="m-list-desc">{{
                        data2.header[0].revisi_ke
                          ? data2.header[0].revisi_ke
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Sales Notif Number</span>
                      <span class="m-list-desc">{{
                        data2.header[0].no_notif
                          ? data2.header[0].no_notif
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Site</span>
                      <span class="m-list-desc">{{
                        data2.header[0].site
                          ? data2.header[0].site
                          : "-"
                      }}</span>
                    </li>
                    <li>
                      <span class="m-list-title" for>Plafon Type</span>
                      <span class="m-list-desc">{{
                        data2.header[0].type_plafon
                          ? data2.header[0].type_plafon
                          : "-"
                      }}</span>
                    </li>
                  </ul>
                </div>
              </a-card>
            </a-col>

            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-collapse
                :class="getScreen ? 'margin-top' : ''"
                :activeKey="!getScreen ? 1 : 0"
              >
                <a-collapse-panel key="1">
                  <div
                    class="m-display-flex space-between align-middle"
                    slot="header"
                  >
                    <h4 class="margin-remove">Transaction Status</h4>
                    <div v-if="data2.status_app">
                      <Status :status="data2.status_besar" />
                      <a-button
                        @click="historyToggle"
                        type="default"
                        size="small"
                        class="margin-right-small"
                      >
                        <a-icon type="undo" />
                      </a-button>
                    </div>
                  </div>
                  <div style="max-height: 375px;overflow: auto;">
                    <a-timeline class="m-timeline" v-if="data2.status_app">
                      <a-timeline-item color="green">
                        <div class="m-timeline-title">
                          Creator -
                          {{
                            data2.header[0].penyusun_anggaran
                              ? data2.header[0].penyusun_anggaran
                              : "-"
                          }}
                          <!-- Creator - {{ data2.status_app[0].tlc }} -->
                        </div>
                        <div class="m-timeline-body">
                          <h4 class="margin-remove">
                            {{
                              moment(data2.status_app[0].tgl_aksi).format(
                                getDefaultDateFormat
                              )
                            }}
                          </h4>
                          <span
                            class="m-text-small"
                            v-if="data2.status_app[0].catatan"
                            >{{ data2.status_app[0].catatan }}</span
                          >
                          <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                        </div>
                        <div class="m-timeline-footer">
                          <a-tag color="green">Created</a-tag>
                        </div>
                      </a-timeline-item>
                      <a-timeline-item
                        color="green"
                        v-for="(workflow, i) in data2.status_app"
                        :key="workflow.step_no"
                      >
                        <div class="m-timeline-title">
                          {{ workflow.actor }} - {{ workflow.tlc }}
                        </div>
                        <div class="m-timeline-body">
                          <h4
                            class="margin-remove"
                            v-if="workflow.tgl_aksi !== null"
                          >
                            {{
                              moment(workflow.tgl_aksi).format(
                                getDateTimeFormat
                              )
                            }}
                          </h4>
                          <span class="m-text-small" v-if="workflow.remark">{{
                            workflow.remark
                          }}</span>
                          <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                        </div>
                        <div class="m-timeline-footer">
                          <Status :status="workflow.status" />
                        </div>
                      </a-timeline-item>
                    </a-timeline>
                  </div>
                </a-collapse-panel>
              </a-collapse>
              <a-collapse class="margin-top margin-bottom" activeKey="1">
                <a-collapse-panel key="1">
                  <div
                    class="m-display-flex space-between align-middle"
                    slot="header"
                  >
                    <h4 class="margin-remove">File Attachment</h4>
                    <div>
                      <a-button
                        v-if="isFc && isApprovedView"
                        :disabled="getAuth.divisi[0] !== 'Financial Control'"
                        @click="addLampiran"
                        type="default"
                        size="small"
                        class="margin-right-small"
                      >
                        upload
                        <a-icon type="upload" />
                      </a-button>
                    </div>
                  </div>
                  <a-list itemLayout="horizontal" :dataSource="data2.lampiran">
                    <Empty
                      v-if="
                        data2.lampiran
                          ? data2.lampiran.length <= 0
                          : data2.lampiran
                      "
                    />
                    <a-list-item slot="renderItem" slot-scope="item">
                      <a-list-item-meta>
                        <div slot="title">
                          <a
                            @click="handleDownload(item)"
                            class="margin-remove m-text-dots"
                          >
                            {{ item.jenis ? item.jenis : "-" }}
                          </a>
                        </div>
                        <div slot="description">
                          <div class="m-display-flex space-between nowrap">
                            <h4 class="margin-remove m-text-dots">
                              {{ item.fungsi }}
                            </h4>
                            <a-button
                              :disabled="getAuth.divisi[0] !== 'Akuntansi'"
                              @click="handleRemoveExisting(item.id_anggaran_doc)"
                              size="small"
                              type="danger"
                              icon="delete"
                            ></a-button>
                          </div>
                          {{ item.tanggal }} | {{ item.tlc }}
                        </div>
                      </a-list-item-meta>
                    </a-list-item>
                  </a-list>
                </a-collapse-panel>
              </a-collapse>

              <!-- <a-collapse class="margin-top margin-bottom" activeKey="1" v-if="isApprovedView">
                <a-collapse-panel key="1">
                  <div
                    class="m-display-flex space-between align-middle"
                    slot="header"
                  >
                    <h4 class="margin-remove">Draft List</h4>
                  </div>

                  <a-list :data-source="data2.draft">
                    <Empty
                      v-if="data2.draft ? data2.draft.length <= 0 : data2.draft"
                    />
                    <a-list-item slot="renderItem" slot-scope="item, index">
                      <a-list-item-meta :description="item.last_update+ ' | ' +item.tlc_create">
                        <a slot="title" @click.prevent="toManifestDraft(item.anggaran_id)">{{ item.cost_center_kode }}</a>
                      </a-list-item-meta>
                      <div>
                        <a-button
                          @click="handleConfirmDelete(item.anggaran_id)"
                          size="small"
                          type="danger"
                          icon="delete"
                        ></a-button>
                      </div>
                    </a-list-item>
                  </a-list>

                </a-collapse-panel>
              </a-collapse> -->

              <!-- <a-collapse v-if="data2.history && data2.history.length > 0 && isApprovedView" class="margin-top margin-bottom" activeKey="1">
                <a-collapse-panel key="1">
                  <div
                    class="m-display-flex space-between align-middle"
                    slot="header"
                  >
                    <h4 class="margin-remove">History Draft</h4>
                  </div>

                  <a-list :data-source="data2.history">
                    <Empty
                      v-if="data2.history ? data2.history.length <= 0 : data2.history"
                    />
                    <a-list-item slot="renderItem" slot-scope="item, index">
                      <a-list-item-meta :description="item.last_update+ ' | ' +item.tlc_create">
                        <router-link 
                          slot="title"
                          :to="{ path: `/manifestanggaran/history/${item.his_id}` }"
                          tag="a"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {{ item.cost_center_kode }}
                        </router-link>
                        -- <a slot="title" @click.prevent="toManifestDraft(item.anggaran_id)">{{ item.cost_center_kode }}</a> --
                      </a-list-item-meta>
                    </a-list-item>
                  </a-list>

                </a-collapse-panel>
              </a-collapse> -->
            </a-col>
  
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }"> </a-col>
  
            <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
              <span slot="title">
                <a-icon type="reload" />&nbsp;History Status
              </span>
  
              <ul class="m-list-wrapper bordered">
                <li
                  v-for="history in data2.notifikasi"
                  :key="history.id_notifikasi"
                >
                  <div v-if="history.aksi === '1' || history.aksi === '3'">
                    <div class="m-display-flex space-between">
                      <h3 class="margin-remove m-list-title">
                        {{ history.as_from }} | {{ history.tlc_from }}
                      </h3>
                      <Status :status="history.deskripsi" />
                    </div>
                    <span class="m-list-desc">{{
                      moment(history.tgl_notif).format(getDateTimeFormat)
                    }}</span>
                  </div>
                  <div v-else-if="history.aksi === '2' || history.aksi === '4'">
                    <div class="m-display-flex space-between">
                      <h3
                        class="margin-remove m-list-title"
                        v-if="
                          history.aksi === '4' && history.deskripsi === 'Edited'
                        "
                      >
                        {{ history.as_from }} | {{ history.tlc_from }}
                      </h3>
                      <h3 class="margin-remove m-list-title" v-else>
                        {{ history.as_to }} | {{ history.tlc_to }}
                      </h3>
                      <Status :status="history.deskripsi" />
                    </div>
                    <span class="m-list-desc">{{
                      moment(history.tgl_notif).format(getDateTimeFormat)
                    }}</span>
                  </div>
                </li>
              </ul>
            </a-modal>
  
            <a-modal
              v-model="visibleLampiran"
              @ok="addLampiran"
              :footer="null"
              @cancel="cancelLampiran"
            >
              <span slot="title">
                <a-icon type="reload" />&nbsp;Upload Attachments
              </span>
  
              <a-form :form="formLampiran">
                <a-form-item label="Document Type">
                  <a-select
                    v-decorator="['jenis', { rules: [{ required: true }] }]"
                  >
                    <!--                  <a-select-option value="COC">COC</a-select-option>-->
                    <!--                  <a-select-option value="Test Report">Test Report</a-select-option>-->
                    <!--                  <a-select-option value="Packing Report">Packing Report</a-select-option>-->
                    <!--                  <a-select-option value="QC Report">QC Report</a-select-option>-->
                    <a-select-option value="Other">Other</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="Document Description">
                  <a-input
                    autocomplete="off"
                    v-decorator="['fungsi', { rules: [{ required: true }] }]"
                  ></a-input>
                </a-form-item>
  
                <a-form-item label="Upload Document File">
                  <a-upload
                    :remove="handleRemoveLampiran"
                    v-decorator="[
                      'file_list_lampiran',
                      { rules: [{ required: true }] },
                    ]"
                    :disabled="fileListLampiran.length > 0"
                    :fileList="fileListLampiran"
                    :beforeUpload="beforeUploadLampiran"
                  >
                    <a-button> <a-icon type="upload" />Select File </a-button>
                  </a-upload>
                </a-form-item>
  
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    @click="handleUploadLampiran"
                    block
                    type="danger"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </a-modal>
          </a-row>

          <a-row>
            <!-- here alocation -->
              <a-table
                v-if="isApprovedView"
                :rowKey="(record, index) => {return index;}"
                :columns="columnsResume"
                :dataSource="data2.resume"
                :pagination="false"
                bordered
                :loading="loadingResume"
                :scroll="{ x: 1500 }"
              >
                <span slot="budgeting"
                  >BUDGETING
                  <a-tag>{{ data2.header[0].kode_cost_center }}</a-tag>
                </span>
                <span slot="title_directorate">
                  DIRECTORATE
                </span>
                <span slot="title_budget">
                  TOTAL BUDGET<br>
                  (a)
                </span>
                <span slot="title_alocated">
                  ALLOCATED<br>
                  (b)
                </span>
                <span slot="title_balance_allocated">
                  BALANCE ALLOCATED<br>
                  (c = b-d)
                </span>
                <span slot="title_realization">
                  REALIZED<br>
                  (d = e+f)
                </span>
                <span slot="title_transfer">
                  TRANSFERRED<br>
                  (e)
                </span>
                <span slot="title_not_yet_transfer">
                  NOT YET TRANSFERRED<br>
                  (f)
                </span>
                <span slot="title_balance">
                  BALANCE BUDGET<br>
                  (a-b)
                </span>
                <span
                  slot="peruntukan"
                  slot-scope="text, record, index"
                  :class="data2.resume.length - 1 == index ? 'textbold' : ''"
                >
                  {{ text }}
                </span>
                <span
                  :class="data2.resume.length - 1 == index ? 'textbold' : ''"
                  slot="budget"
                  slot-scope="text, record, index"
                >
                  {{ formatCurrency(text.mata_uang, text) }}
                </span>
                <span
                  :class="data2.resume.length - 1 == index ? 'textbold' : ''"
                  slot="alocated"
                  slot-scope="text, record, index"
                >
                  {{ formatCurrency(text.mata_uang, text) }}
                </span>
                <span
                  :class="data2.resume.length - 1 == index ? 'textbold' : ''"
                  slot="balance_allocated"
                  slot-scope="text, record, index"
                >
                  {{ formatCurrency(text.mata_uang, text) }}
                </span>
                <span
                  :class="data2.resume.length - 1 == index ? 'textbold' : ''"
                  slot="realization"
                  slot-scope="text, record, index"
                >
                  {{ formatCurrency(text.mata_uang, text) }}
                </span>
                <span
                  :class="data2.resume.length - 1 == index ? 'textbold' : ''"
                  slot="transfer"
                  slot-scope="text, record, index"
                >
                  {{ formatCurrency(text.mata_uang, text) }}
                </span>
                <span
                  :class="data2.resume.length - 1 == index ? 'textbold' : ''"
                  slot="transfer"
                  slot-scope="text, record, index"
                >
                  {{ formatCurrency(text.mata_uang, text) }}
                </span>
                <span
                  slot="not_yet_transfer"
                  slot-scope="text, record, index"
                  :class="data2.resume.length - 1 == index ? 'textbold' : ''"
                >
                  {{ formatCurrency(text.mata_uang, text) }}
                </span>
                <span
                  slot="balance"
                  slot-scope="text, record, index"
                  :class="data2.resume.length - 1 == index ? 'textbold' : ''"
                >
                  {{ formatCurrency(text.mata_uang, text) }}
                </span>
              </a-table>

              <TableAnggaran
                v-if="!isApprovedView && genColumn.length > 0 && data2.tree.length > 0"
                :source="data2.tree"
                :column="genColumn"
                :datatree="tree"
                :listTahun="listThn"
                :allowtoEdit="allowtoEdit"
                :headerTitle="headerTitle"
                :draft="allowDraft"
                @confirm_draft="handleConfirmDraft"
              />

              <!-- <a-table
                v-if="isPreview"
                class="ccd margin-top"
                :columns="columns"
                :rowKey="(record, index) => {return index;}"
                :dataSource="data2.dtl"
                :pagination="false"
                size="small"
                :scroll="{ x: 1920 }"
                bordered
              >
                <template slot="title">
                  <a-row :gutter="16" type="flex" justify="space-between" align="middle">
                    <a-col>
                      <div class="ant-card-head-title" ><b>Budget Detail</b></div>
                    </a-col>
                    <a-col>
                      <a-input-search
                        v-model="search"
                        placeholder="Search Budget Detail .. "
                      />  
                    </a-col>
                  </a-row>
                </template>

                <template slot="no" slot-scope="text, data, index">
                  {{ index + 1 }}
                </template>

                <template slot="budget" slot-scope="item, data, index">
                  <span style="display: block; text-align: left;" :class="itemChild(data)">{{ item }}</span>
                </template>

                <template slot="kode_anggaran" slot-scope="item">
                  <span>{{ item }}</span>
                </template>

                <template slot="unit_price" slot-scope="item, data, index">
                  <CurrencyJustified
                    v-if="data.type == 'item'"
                    currencyValue="IDR"
                    :valueNumber="item"
                  />
                </template>

                <template v-for="bln in bulan" :slot="bln.bulan" slot-scope="item, data, index">
                  <CurrencyJustified
                  v-if="data.type == 'item'"
                    currencyValue="IDR"
                    :valueNumber="item"
                  />
                </template>

                <template slot="sub_total" slot-scope="item, data, index">
                  <CurrencyJustified
                    v-if="data.type == 'item'"
                    currencyValue="IDR"
                    :valueNumber="item"
                  />
                </template>

                <template slot="deskripsi" slot-scope="item">
                  {{ item.keterangan }}
                </template>

                <template slot="footer">
                  <a-row :gutter="16" type="flex" justify="space-between" align="top">
                    !-- <a-col style="text-align: right;">
                      <a-statistic title="Total Deduction Value (IDR)" :value="total_deduction" />
                      <a-button type="primary" icon="save" class="margin-top" @click="handleSubmit" :loading="loading.submit" :disabled="!lock_header">Submit</a-button>
                    </a-col> --
                  </a-row>
                </template>
              </a-table> -->

              <a-card class="margin-top" v-if="enable_edit">
                <div slot="title">
                  <span>Type Plafon</span>
                </div>

                <a-form :form="form">
                  <a-row :gutter="16" type="flex">
                    <a-col :lg="{ span: 12 }">
                      <a-form-item label="Type">
                        <a-select
                          showSearch
                          @change="onChangeTypePlafon"
                          v-decorator="['type_plafon', { rules: [{ required: true }], initialValue: data2.header.type_plafon  }]"
                        >
                          <a-select-option v-for="item in type_plafon" :key="item.value" :value="item.value">
                            {{ item.name }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-form>

              </a-card>

              <a-card class="margin-top" v-if="enable_edit">
                <div slot="title">
                  <span>Directorate of Allocation</span>
                </div>

                <a-form :form="form">
                  <a-row :gutter="16" type="flex">
                    <a-col v-for="value in data2.peruntukan" :key="value.peruntukan" :lg="{ span: 12 }">
                      <a-form-item :label="value.peruntukan">
                        <a-select
                          showSearch
                          @change="onChangePeruntukan($event, value)"
                          :loading="loading_update && id_update == value.peruntukan_id"
                          v-decorator="[value.peruntukan, { rules: [{ required: true }], initialValue: value.id_direktorat, }]"
                        >
                          <a-select-option v-for="item in data2.direktorat" :key="item.id_direktorat" :value="item.id_direktorat">
                            {{ item.nama_direktorat }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-form>

              </a-card>

              <a-card class="margin-top" v-if="data2.aksi && data2.aksi.length > 0">
                <a-form :form="form">
                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="[
                        'catatan',
                        { rules: [{ required: false }] },
                      ]"
                    />
                  </a-form-item>

                  <a-form-item label="Action">
                    <a-select
                      showSearch
                      v-decorator="['action', { rules: [{ required: true }] }]"
                    >
                      <a-select-option v-for="item in data2.aksi" :key="item.aksi" :value="item.aksi">
                        {{ item.aksi }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                </a-form>
                <div style="display: flex; justify-content: end;">
                  <a-button :loading="loading_submit" type="primary" icon="save" @click="handleSubmitManifest">Submit</a-button>
                </div>
              </a-card>
          </a-row>

          <a-row v-if="isApprovedView" class="margin-top">
            <TableAnggaran
              v-if="genColumn.length > 0 && data2.tree.length > 0"
              :source="data2.tree"
              :column="genColumn"
              :datatree="tree"
              :listTahun="listThn"
              :allowtoEdit="allowtoEdit"
              :headerTitle="headerTitle"
              :draft="allowDraft"
              @confirm_draft="handleConfirmDraft"
            >
            <template #button-extra v-if="allowDraft">
              <!-- <a-button
                v-if="(data2.draft && data2.draft.length > 0) || data2.header[0].sts_close == '1'"
                type="danger"
                icon="edit"
                class="margin-right"
                @click="toManifestDraft(data2.draft[0].anggaran_id)"
              >
                Draft
              </a-button> -->
              
              <a-button v-if="!((data2.draft && data2.draft.length > 0) || data2.header[0].sts_close == '1')" :loading="loading_draft" type="primary" icon="edit" @click="handleConfirmDraft">Revise Budget</a-button>
            </template>
            <template #button-extra v-else>
              <a-button
                type="primary"
                icon="setting"
                class="margin-right"
                @click="toPage('coa_configuration')"
              >
                COA Configuration
              </a-button>
            </template>
          </TableAnggaran>
          </a-row>

        </template>
        <a-drawer
          title="Upload Document"
          placement="bottom"
          height="310"
          :closable="false"
          @close="onClose"
          :visible="uploadVisible"
        >
          <a-form :form="form">
            <a-form-item label="Document Description">
              <a-input
                v-decorator="['deskripsi', { rules: [{ required: true }] }]"
              ></a-input>
            </a-form-item>
            <a-form-item label="Upload Document File">
              <a-upload
                :showUploadList="true"
                :fileList="push"
                :beforeUpload="beforeUpload"
                v-decorator="[
                  'upload',
                  { rules: [{ required: true }], valuePropName: 'push' },
                ]"
              >
                <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
              </a-upload>
            </a-form-item>
            <a-form-item>
              <a-button
                type="primary"
                block
                @click="handleNew"
                :loading="btnLoading"
                >Add</a-button
              >
            </a-form-item>
          </a-form>
        </a-drawer>

        <a-modal v-model="visibleDraftHistory" @cancel="visibleDraftHistory!=visibleDraftHistory" :footer="null" :maskClosable="false" width="240px">
          <span slot="title">
            <a-icon type="clock-circle" />&nbsp;History Budget
          </span>
          <div style="max-height: 80vh ;overflow: auto;">
            <ul class="m-list-wrapper bordered">
              <li
                v-for="(items,index) in data2.history"
                :key="index"
              >
                <div>
                  <div class="ant-card-head-title m-display-flex space-between">
                    <router-link 
                      slot="title"
                      :to="{ path: `/manifestanggaran/history/${items.his_id}` }"
                      tag="a"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                        <h3 class="margin-remove m-list-title">
                          REV : {{ items.revisi_no }} | {{ moment(items.create_dt).format(getDateTimeFormat) }}
                        </h3>
                    </router-link>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </a-modal>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import lottie from "vue-lottie";
  import { mapGetters } from "vuex";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import Status from "@/components/Status.vue";
  import moment from "moment";
  import notfound from "@/assets/anim/404.json";
  import HandleRoute from "@/mixins/HandleRoute";
  import TableAnggaran from "@/components/TableCustomAnggaran.vue";
  import GlobalMethod from "@/mixins/GlobalMethod.js";
  import _ from "lodash";
import router from "../../../router";

  const bulan = [
    { bulan: "januari", short: "jan" },
    { bulan: "februari", short: "feb" },
    { bulan: "maret", short: "mar" },
    { bulan: "april", short: "apr" },
    { bulan: "mei", short: "mei" },
    { bulan: "juni", short: "jun" },
    { bulan: "juli", short: "jul" },
    { bulan: "agustus", short: "agu" },
    { bulan: "september", short: "sep" },
    { bulan: "oktober", short: "okt" },
    { bulan: "november", short: "nov" },
    { bulan: "desember", short: "des" }
  ];
  
  export default {
    name: "manifestAnggaran",
    props: ["id", "budget_thn", "rabview", "status"],
    components: { "m-anim": lottie, TableAnggaran, Status },
    mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
    data() {
      const columnModal = [
        {
          title: "Deskripsi",
          key: "deskripsi",
          scopedSlots: { customRender: "deskripsi" },
          sorter: (a, b) => a.jenis.length - b.jenis.length,
        },
        {
          title: "Tanggal Buat",
          key: "tanggal",
          dataIndex: "tanggal_buat",
          width: 150,
          sorter: (a, b) =>
            moment(a.tanggal_buat).unix() - moment(b.tanggal_buat).unix(),
        },
        {
          title: "Status",
          key: "status",
          width: 120,
          scopedSlots: { customRender: "status" },
          sorter: (a, b) => a.status.length - b.status.length,
        },
        {
          title: "Value",
          key: "value",
          align: "right",
          scopedSlots: { customRender: "value" },
          sorter: (a, b) => a.value - b.value,
        },
        {
          title: "Realisasi",
          key: "realization",
          align: "right",
          scopedSlots: { customRender: "realization" },
        },
      ];
      const columnRab = [
        {
          title: "Departement",
          key: "title",
          scopedSlots: { customRender: "dataTitle" },
        },
        {
          title: "Total Budget",
          key: "anggaran",
          dataIndex: "anggaran",
          scopedSlots: { customRender: "anggaran" },
        },
        {
          title: "Total Allocation",
          key: "pemakaian",
          dataIndex: "pemakaian",
          scopedSlots: { customRender: "pemakaian" },
        },
        {
          title: "Total Realization",
          key: "realisasi",
          dataIndex: "realisasi",
          scopedSlots: { customRender: "realization" },
        },
        {
          title: "Allocation Budget",
          key: "sisa",
          dataIndex: "sisa",
          scopedSlots: { customRender: "sisa" },
        },
        {
          title: "Realization Budget",
          key: "sisa_realisasi",
          dataIndex: "sisa_realisasi",
          scopedSlots: { customRender: "trealization" },
        },
      ];
      const columnsResume = [
        {
          slots: { title: "budgeting" },
          key: "peruntukan",
          dataIndex: "peruntukan",
          scopedSlots: { customRender: "peruntukan" },
        },
        {
          slots: { title: 'title_directorate' },
          key: "directorate",
          dataIndex: "direktorat",
          align: "left",
        },
        {
          slots: { title: 'title_budget' },
          key: "budget",
          dataIndex: "budget",
          align: "right",
          scopedSlots: { customRender: "budget" },
        },
        {
          title: 'ALLOCATION',
          children: [
            {
              slots: { title: 'title_alocated' },
              key: "alocated",
              dataIndex: "alocated",
              align: "right",
              scopedSlots: { customRender: "alocated" },
            },
            {
              slots: { title: 'title_balance_allocated' },
              key: "balance_allocated",
              dataIndex: "balance_allocated",
              align: "right",
              scopedSlots: { customRender: "balance_allocated" },
            },
          ]
        },
        {
          title: 'REALIZATION',
          children: [
            {
              slots: { title: 'title_realization' },
              key: "realization",
              dataIndex: "realization",
              align: "right",
              scopedSlots: { customRender: "realization" },
            },
            {
              slots: { title: 'title_transfer' },
              key: "transfer",
              dataIndex: "transfer",
              align: "right",
              scopedSlots: { customRender: "transfer" },
            },
            {
              slots: { title: 'title_not_yet_transfer' },
              key: "not_yet_transfer",
              dataIndex: "not_yet_transfer",
              align: "right",
              scopedSlots: { customRender: "not_yet_transfer" },
            },
          ]
        },
        {
          slots: { title: 'title_balance' },
          key: "balance",
          dataIndex: "balance",
          align: "right",
          scopedSlots: { customRender: "balance" },
        },
      ];
      
      const type_plafon = [
        {name: "DIREKTORAT (DR)", value: 'Operational'},
        {name: "FIX COST (FX)", value: 'Fixed Cost'},
        {name: "IKN (IK)", value: 'IKN'},
        {name: "HALE (HL)", value: 'HALE'},
      ]

      return {
        bulan,
        isApprovedView: false,
        isPreview: false,
        loading: true,
        loadingModal: true,
        loadingResume: false,
        btnLoading: false,
        loading_close: false,
        loading_update: false,
        loading_submit: false,
        enable_edit: false,
        id_update: '',
        notfound: { animationData: notfound, loop: true },
        data: {},
        data2: {},
        dataTable: {},
        uploadVisible: false,
        push: [],
        search: "",
        pagination: {
          onChange: (page) => {},
          pageSize: 5,
          size: "small",
        },
        rabVisibleDtl: false,
        dataRabVisibleDtl: {
          title: "",
          data: {
            pengeluran: "",
          },
        },
        columnsResume,
        columnRab,
        columnModal,
        type_plafon,
        type_plafon_selected: null,
        isRabExist: true,
        genColumn: [],
        listThn: { dtl: [], rekap: [] },
        tree: [],
        visibleHistory: false,
        visibleLampiran: false,
        fileListLampiran: [],
        headerTitle: {},
        json_fields: {
          "Complete name": "name",
          City: "city",
          Telephone: "phone.mobile",
          "Telephone 2": "phone.landline",
        },
        json_data: [
          {
            name: "Tony Peña",
            city: "New York",
            country: "United States",
            birthdate: "1978-03-15",
            phone: {
              mobile: "1-541-754-3010",
              landline: "(541) 754-3010",
            },
          },
          {
            name: "Thessaloniki",
            city: "Athens",
            country: "Greece",
            birthdate: "1987-11-23",
            phone: {
              mobile: "+1 855 275 5071",
              landline: "(2741) 2621-244",
            },
          },
        ],
  
        json_meta: [
          [
            {
              key: "charset",
              value: "utf-8",
            },
          ],
        ],
        allowtoEdit: false,
        allowDraft: false,
        loading_draft: false,
        visibleDraftHistory: false,
      };
    },
    computed: {
      ...mapGetters([
        "getScreen",
        "getAuth",
        "getIsSpecialMenu",
        "getDateTimeFormat",
        "getDefaultDateFormat",
      ]),
      searchbox() {
        let data = this.dataRabVisibleDtl.data.pengeluaran;
  
        if (this.search) {
          data = _.filter(
            data,
            (value) =>
              (value.jenis ? value.jenis : "")
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0 ||
              (value.status ? value.status : "")
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0 ||
              (value.no ? value.no : "")
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0 ||
              (value.value ? value.value : "").indexOf(
                this.search.toLowerCase()
              ) >= 0 ||
              (value.realisasi ? value.realisasi : "").indexOf(
                this.search.toLowerCase()
              ) >= 0 ||
              this.moment(value.tanggal_buat)
                .format(this.getDefaultDateFormat)
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0
          );
        }
  
        let totalallocation = 0;
        let totalrealisasi = 0;
  
        if (data) {
          data.forEach((list) => {
            totalallocation = totalallocation + parseFloat(list.value);
            totalrealisasi =
              totalrealisasi + parseFloat(list.realisasi ? list.realisasi : 0);
          });
        }
  
        return { data, totalallocation, totalrealisasi };
      },
      columns(){
        const kolom = [
          {
            title: "No",
            dataIndex: "no",
            key: "no",
            width: "50px",
            align: "center",
            scopedSlots: { customRender: "no" },
          },
          {
            title: "Budgeting",
            dataIndex: "budget",
            key: "budget",
            width: "170px",
            align: "center",
            scopedSlots: { customRender: "budget" }
          },
          {
            title: 'Year ' + this.data2.year,
            children: [
              {
                title: "Code Budget",
                dataIndex: "kode_anggaran",
                key: "kode_anggaran",
                width: "170px",
                scopedSlots: { customRender: "kode_anggaran" },
              },
              {
                title: "Unit",
                dataIndex: "unit",
                key: "unit",
                align: "center",
                width: "100px",
                scopedSlots: { customRender: "unit" },
              },
              {
                title: "Unit Price",
                dataIndex: "unit_price",
                key: "unit_price",
                width: "180px",
                scopedSlots: { customRender: "unit_price" },
              },
              {
                title: "Jan",
                dataIndex: "januari",
                key: "januari",
                width: "180px",
                scopedSlots: { customRender: "januari" },
              },
              {
                title: "Feb",
                dataIndex: "februari",
                key: "februari",
                width: "180px",
                scopedSlots: { customRender: "februari" },
              },
              {
                title: "Mar",
                dataIndex: "maret",
                key: "maret",
                width: "180px",
                scopedSlots: { customRender: "maret" },
              },
              {
                title: "Apr",
                dataIndex: "april",
                key: "april",
                width: "180px",
                scopedSlots: { customRender: "april" },
              },
              {
                title: "May",
                dataIndex: "mei",
                key: "mei",
                width: "180px",
                scopedSlots: { customRender: "mei" },
              },
              {
                title: "Jun",
                dataIndex: "juni",
                key: "juni",
                width: "180px",
                scopedSlots: { customRender: "juni" },
              },
              {
                title: "Jul",
                dataIndex: "juli",
                key: "juli",
                width: "180px",
                scopedSlots: { customRender: "juli" },
              },
              {
                title: "Aug",
                dataIndex: "agustus",
                key: "agustus",
                width: "180px",
                scopedSlots: { customRender: "agustus" },
              },
              {
                title: "Sep",
                dataIndex: "september",
                key: "september",
                width: "180px",
                scopedSlots: { customRender: "september" },
              },
              {
                title: "Okt",
                dataIndex: "oktober",
                key: "oktober",
                width: "180px",
                scopedSlots: { customRender: "oktober" },
              },
              {
                title: "Nov",
                dataIndex: "november",
                key: "november",
                width: "180px",
                scopedSlots: { customRender: "november" },
              },
              {
                title: "Des",
                dataIndex: "desember",
                key: "desember",
                width: "180px",
                scopedSlots: { customRender: "desember" },
              },
              {
                title: "Sub Total",
                dataIndex: "sub_total",
                key: "sub_total",
                align: "right",
                width: "180px",
                scopedSlots: { customRender: "sub_total" },
              },
            ]
          }
        ]
          return kolom
      },

      isFc(){
        let res = false
        this.getAuth.divisi.forEach(element => {
          if(element.toLowerCase()=='financial control'){
            res = true
          }
        });
        return res
      }
    },
    beforeCreate() {
      this.form = this.$form.createForm(this);
      this.formLampiran = this.$form.createForm(this);
    },
    created() {
      this.switchFetchManifest();
    },
    watch: {
      id() {
        if (this.id) {
          this.switchFetchManifest();
        }
      },
    },
    methods: {
      moment,
      switchFetchManifest(){
        if(this.status == 'Approved'){
          this.isApprovedView = true
          this.fetchManifest()
        }else {
          this.isPreview = true
          this.fetchManifestAction()
        }
      },
      async fetchManifestAction() {
        this.loading = true;

        const payload = {
            id_manifest: this.id
        }
        
        await axios({
          method: "get",
          url: this.$serviceUrl + "anggaran",
          params: payload,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.data2 = this.normalizePreviewData(response.data);
            this.enable_edit = response.data.is_edit_peruntukan
            if (this.data2) {
              this.headerTitle = this.data2.header;
              // this.getbidang();
              console.log(this.data2.tahun, this.data2)
              if(!this.data2.tahun){
                this.data2['tahun'] = [{
                  tahun: this.data2.year
                }]
              }
              console.log('hasil', this.data2.tahun)
              this.generateColumn();
            }
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            
            if (!err.response) {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses);
              this.$router.go(-1);
            } else {
              this.displayMessage("denied-manifest");
              this.$router.push({ name: "beranda" });
            }
          });
      },
      async fetchManifest() {
        this.loading = true;
        
        const payload = {
            tlc: this.getAuth.username,
            anggaran_id: this.id,
            tahun: this.budget_thn,
        }
        
        await axios({
          method: "get",
          url: this.$serviceUrl + "anggaran/manifest1",
          params: payload,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.data2 = response.data;
            if (this.data2) {
              this.data2.header[0].available = false;
              this.headerTitle = this.data2.header;
              this.allowDraft = this.data2.can_edit
              // this.getbidang();
            }
            this.loading = false;
            this.fetchresume();
          })
          .catch((err) => {
            if (!err.response) {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses);
              this.$router.go(-1);
            } else {
              this.displayMessage("denied-manifest");
              this.$router.push({ name: "beranda" });
            }
          });
        this.generateColumn();
      },

      async handleConfirmDraft(){
        const that = this;
        let title = "";
        title = "Do you want to edit this as a draft? ?";
        that.$confirm({
          title: title,
          content: "Yes / No?",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            that.onSubmitDraft()
          },
          onCancel() {},
        })
      },

      handleConfirmDelete(id){
        const that = this;
        let title = "";
        title = "Do you want to delete this draft ?";
        that.$confirm({
          title: title,
          content: "Yes / No?",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            that.onDeleteDraft(id)
          },
          onCancel() {},
        })
      },

      async onDeleteDraft(id){
        try {
          const payload = {
            anggaran_id: id
          }

          const response = await axios({
            method: "DELETE",
            url: this.$serviceUrl + "anggaran/draft",
            data: payload,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
          })

          if(response){
            const filteredData = this.data2.draft.filter((item) => item.anggaran_id !== id)
            this.data2.draft = filteredData
          }

        } catch (error) {
          console.log(error);
        }
      },

      async onSubmitDraft(){
        try {
          this.loading_draft = true
          const payload = {
            anggaran_id: this.data2.anggaran_id
          }

          const response = await axios({
            method: "POST",
            url: this.$serviceUrl + "anggaran/draft",
            data: payload,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
          })

          this.loading_draft = false
          if(response){
            this.$router.push({
              name: 'anggaran.manifest.draft',
              params: {
                id: response.data.anggaran_id
              }
            })
          }
        } catch (error) {
          this.loading_draft = false
          this.displayMessageValue("error", error.response.data.message);
        }
      },

      normalizePreviewData(data) {
        const { header, workflow, history } = data;

        const normalizedHeader = [{
          jns_anggaran_id: header.jns_anggaran_id,
          jenis_anggaran: header.budget_type,
          kode_cost_center: header.cost_center_kode,
          nama_pekerjaan: header.job_name,
          klien: header.klien,
          site: header.site,
          penyusun_anggaran: header.compiler,
          kuasa_anggaran_marketing: header.budget_marketing_ibd,
          kuasa_anggaran_operasi: header.budget_operation_authority,
          kuasa_anggaran_ga: header.budget_ga_authority,
          tahun_anggaran: header.fiscal_year,
          revisi_ke: header.type_flag || "0",  // tanpa ??
          no_notif: header.notif_number,
          sts_close: header.sts_close,
          type_plafon: header.type_plafon,
          anggaran_id: header.anggaran_id
        }];

        const normalizedStatusApp = workflow.map(w => ({
          id_status: w.id_status,
          id_wf: "anggaran01",
          tlc: w.tlc,
          step_no: w.step_no,
          status: w.status,
          remark: w.remark,
          id_lk: w.id_tr_fk,
          tgl_aksi: w.tgl_aksi,
          actor: w.actor,
          jenis: w.step_no == "4" ? "Approve" : "Verifikator",
          job_desc: w.actor
        }));

        return {
          ...data,
          header: normalizedHeader,
          status_app: normalizedStatusApp,
          notifikasi: history
        };
      },

      itemChild(val){
        let c = ''
        if(val.kode_anggaran == null){
          c = 'text-bold';
          if(val.type == 'peruntukan'){
            c = c + ' margin-1'
          } else if(val.type == 'subperuntukan'){
            c = c + ' margin-2'
          }
        }else {
          c = 'margin-item'
        }

        return c;
      },

      fetchresume(){
        this.loadingResume = true
        axios({
          method: "get",
          url: this.$serviceUrl + "anggaran/resume",
          params: {
            anggaran_id: this.id,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
        .then((response) => {
          this.data2.resume = response.data.resume
          this.data2.resume.forEach((element,index)=>{
            this.data2.resume[index]['key'] = index;
          });
          this.loadingResume = false
        })
        .catch(() => {
          this.loadingResume = false
        })
      },

      handleCancel() {
        this.previewVisible = false;
      },
      handleViewDokumen(file) {
        const url = this.$serviceUrl + file.url;
        window.open(url, "_blank");
      },
      showDrawer() {
        this.uploadVisible = true;
      },
      onClose() {
        this.uploadVisible = false;
      },
      beforeUpload(file) {
        const FileSize = file.size / 1024 / 1024;
        if (FileSize > 5) {
          this.displayMessage("large-file-5mb");
        } else {
          this.push = [file];
          return false;
        }
      },
      handleNew() {
        this.confirmMessage("confirm-save");
      },
      handleNewProcess() {
        this.form.validateFields((err, values) => {
          if (err) {
            this.btnLoading = false;
            this.displayMessage("form-warning");
            return;
          }
  
          let addData = new FormData();
          addData.append("kode_proyek", this.id);
          addData.append("deskripsi_doc", values.deskripsi);
          addData.append("tlc", this.getAuth.username);
          addData.append("file_transfer", this.push[0]);
  
          this.btnLoading = true;
          axios({
            method: "post",
            url: this.$serviceUrl + "project/doc_closing",
            processData: false,
            data: addData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then(() => {
              this.btnLoading = false;
              this.uploadVisible = false;
              this.switchFetchManifest();
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      },
      handleRemove(item) {
        this.confirmMessageValue("confirm-delete", item);
      },
      delete(item) {
        const serviceUrl = this.$serviceUrl;
        const auth = {
          username: this.getAuth.username,
          password: this.getAuth.password,
          apikey: this.getAuth.apikey,
        };
        axios({
          method: "delete",
          url: serviceUrl + "project/doc_closing",
          processData: false,
          data: {
            id_project_doc: item,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            Event.$emit("refresh", true);
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      },
      handleDownload(item) {
        window.open(this.$serviceUrl + item.url, "_blank");
      },
      handleClose() {
        this.confirmMessage("confirm-close");
      },
      close() {
        if (this.data.dokumen_closing.length >= 1) {
          const serviceUrl = this.$serviceUrl,
            auth = {
              username: this.getAuth.username,
              password: this.getAuth.password,
              apikey: this.getAuth.apikey,
            },
            data = new FormData();
  
          data.append("tlc", auth.username);
          data.append("kode_proyek", this.id);
          axios({
            method: "post",
            url: serviceUrl + "project/closing",
            processData: false,
            data: data,
            auth: {
              username: auth.username,
              password: auth.password,
            },
            headers: {
              "X-API-KEY": auth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success-close-project");
              this.$router.go();
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        } else {
          this.displayMessage("warning-emptyDoc");
        }
      },
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;
  
        if (addRemoveClass === "addClass") {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
      hideModal() {
        this.toggleBodyClass("removeClass", "scrollDisable");
        this.rabVisibleDtl = false;
      },
      visibleDtlToggle(item) {
        this.loadingModal = true;
        this.toggleBodyClass("addClass", "scrollDisable");
  
        axios({
          method: "get",
          url: this.$serviceUrl + "project/detil_rab",
          params: {
            kode_proyek: this.id,
            allocation: item.toLowerCase(),
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            let items = {
              title: item,
              data: JSON.parse(JSON.stringify(response.data)),
            };
            this.dataRabVisibleDtl = items;
            this.loadingModal = false;
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          });
        this.rabVisibleDtl = true;
      },
      historyToggle(e) {
        e.stopPropagation();
        this.visibleHistory = !this.visibleHistory;
      },
      addLampiran(e) {
        e.stopPropagation();
        this.visibleLampiran = !this.visibleLampiran;
      },
      beforeUploadLampiran(file) {
        const FileSize = file.size / 1024 / 1024;
        if (FileSize > 5) {
          this.displayMessage("large-file-5mb");
        } else {
          this.fileListLampiran.push(file);
          return false;
        }
      },
      handleRemoveExisting(id) {
        this.confirmMessageValue("confirm-delete", id);
      },
      handleRemoveLampiran(file) {
        const index = this.fileListLampiran.indexOf(file);
        const newFileList = this.fileListLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListLampiran = newFileList;
      },
      executeRemoveLampiran(id) {
        const serviceUrl = this.$serviceUrl;
        const auth = {
          username: this.getAuth.username,
          password: this.getAuth.password,
          apikey: this.getAuth.apikey,
        };
  
        axios({
          method: "delete",
          url: serviceUrl + "anggaran/lampiran",
          processData: false,
          data: {
            id_anggaran_doc: id,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            this.$router.go();
            //Event.$emit("refresh", true);
            if (response.data.message === "Delete Success") {
              this.displayMessage("success-del");
            } else {
              let responses = Object.assign({}, response.data);
              this.displayMessageValue("error", responses);
            }
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          });
      },
      cancelLampiran() {
        this.fileListLampiran = [];
        this.formLampiran.resetFields();
      },
      handleUploadLampiran() {
        this.formLampiran.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }
  
          let formData = new FormData();
          formData.append("id_manifest", this.id);
          formData.append("fungsi", values.fungsi);
          formData.append("jenis", values.jenis);
          formData.append("tlc", this.getAuth.username);
          formData.append("nama_document", values.file_list_lampiran.file);
  
          axios({
            method: "post",
            url: this.$serviceUrl + "anggaran/upload_lampiran",
            processData: false,
            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success-upload");
              this.visibleLampiran = !this.visibleLampiran;
              //Event.$emit("refresh", true);
              this.$router.go();
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      },
  
      generateColumn() {
        let rangethn = [];
        let lop = 0;
        var gencolm = [];
  
        //colom title item / cost center
        gencolm = [
          {
            slots: { title: "customTitleMain" },
            key: "name",
            width: 300,
            fixed: this.getScreen ? '' : "left",
            showcolumn: "",
            scopedSlots: { customRender: "name" },
          },
        ];
        //colom header all tahun
        gencolm.push({
          key: "alltahun",
          slots: { title: "customTitleAllTahun" },
          scopedSlots: { customRender: "alltahun" },
          dataIndex: "rangetahun",
          align: "left",
          children: [],
        });
        this.data2.tahun.forEach((item) => {
          rangethn[lop] = item["tahun"];
  
          //detil
          var dtljson = {
            title: "Year " + item["tahun"],
            scopedSlots: { customRender: "tahun" },
            className: "unhide header th" + item["tahun"],
            children: [
              {
                title: "Code Budget",
                width: 150,
                dataIndex: "kode_anggran" + item["tahun"],
                key: "code" + item["tahun"] + "1",
                align: "left",
                className: "fix th" + item["tahun"],
                scopedSlots: { customRender: "dtlitemcode" },
              },
              {
                title: "Unit",
                width: 50,
                dataIndex: "jumlah" + item["tahun"],
                key: "jumlah" + item["tahun"] + "1",
                align: "center",
                className: "fix th" + item["tahun"],
                //scopedSlots: { customRender: ('dtlitem01') }
              },
              {
                title: "unit price",
                width: 150,
                dataIndex: "harga_satuan" + item["tahun"],
                key: "harga_satuan" + item["tahun"] + "1",
                align: "right",
                className: "fix th" + item["tahun"],
                scopedSlots: { customRender: "dtlitemprice" },
              },
              {
                title: "Jan'" + item["tahun"].substr(2),
                width: 150,
                dataIndex: "bln" + item["tahun"] + "1",
                key: "bln" + item["tahun"] + "1",
                align: "right",
                className: "unhide th" + item["tahun"],
                scopedSlots: { customRender: "dtlitem01" },
              },
              {
                title: "Feb'" + item["tahun"].substr(2),
                width: 150,
                dataIndex: "bln" + item["tahun"] + "2",
                key: "bln" + item["tahun"] + "2",
                align: "right",
                className: "unhide th" + item["tahun"],
                scopedSlots: { customRender: "dtlitem02" },
              },
              {
                title: "Mar'" + item["tahun"].substr(2),
                width: 150,
                dataIndex: "bln" + item["tahun"] + "3",
                key: "bln" + item["tahun"] + "3",
                align: "right",
                className: "unhide th" + item["tahun"],
                scopedSlots: { customRender: "dtlitem03" },
              },
              {
                title: "Apr'" + item["tahun"].substr(2),
                width: 150,
                dataIndex: "bln" + item["tahun"] + "4",
                key: "bln" + item["tahun"] + "4",
                align: "right",
                className: "unhide th" + item["tahun"],
                scopedSlots: { customRender: "dtlitem04" },
              },
              {
                title: "May'" + item["tahun"].substr(2),
                width: 150,
                dataIndex: "bln" + item["tahun"] + "5",
                key: "bln" + item["tahun"] + "5",
                align: "right",
                className: "unhide th" + item["tahun"],
                scopedSlots: { customRender: "dtlitem05" },
              },
              {
                title: "Jun'" + item["tahun"].substr(2),
                width: 150,
                dataIndex: "bln" + item["tahun"] + "6",
                key: "bln" + item["tahun"] + "6",
                align: "right",
                className: "unhide th" + item["tahun"],
                scopedSlots: { customRender: "dtlitem06" },
              },
              {
                title: "Jul'" + item["tahun"].substr(2),
                width: 150,
                dataIndex: "bln" + item["tahun"] + "7",
                key: "bln" + item["tahun"] + "7",
                align: "right",
                className: "unhide th" + item["tahun"],
                scopedSlots: { customRender: "dtlitem07" },
              },
              {
                title: "Aug'" + item["tahun"].substr(2),
                width: 150,
                dataIndex: "bln" + item["tahun"] + "8",
                key: "bln" + item["tahun"] + "8",
                align: "right",
                className: "unhide th" + item["tahun"],
                scopedSlots: { customRender: "dtlitem08" },
              },
              {
                title: "Sep'" + item["tahun"].substr(2),
                width: 150,
                dataIndex: "bln" + item["tahun"] + "9",
                key: "bln" + item["tahun"] + "9",
                align: "right",
                className: "unhide th" + item["tahun"],
                scopedSlots: { customRender: "dtlitem09" },
              },
              {
                title: "Okt'" + item["tahun"].substr(2),
                width: 150,
                dataIndex: "bln" + item["tahun"] + "10",
                key: "bln" + item["tahun"] + "10",
                align: "right",
                className: "unhide th" + item["tahun"],
                scopedSlots: { customRender: "dtlitem10" },
              },
              {
                title: "Nov'" + item["tahun"].substr(2),
                width: 150,
                dataIndex: "bln" + item["tahun"] + "11",
                key: "bln" + item["tahun"] + "11",
                align: "right",
                className: "unhide th" + item["tahun"],
                scopedSlots: { customRender: "dtlitem11" },
              },
              {
                title: "Des'" + item["tahun"].substr(2),
                width: 150,
                dataIndex: "bln" + item["tahun"] + "12",
                key: "bln" + item["tahun"] + "12",
                align: "right",
                className: "unhide th" + item["tahun"],
                scopedSlots: { customRender: "dtlitem12" },
              },
              {
                title: "Sub Total",
                dataIndex: "rekap" + item["tahun"],
                key: "rekap" + item["tahun"],
                align: "right",
                className: "unhide th" + item["tahun"],
                scopedSlots: { customRender: "dtlitemrekap" },
              },
            ],
          };
  
          //rekap
          var dtljson2 = {
            title: "Year " + item["tahun"],
            className: "hide header th" + item["tahun"] + "rekap kolom",
            width: 150,
            children: [
              {
                title: "Code Budget",
                width: 150,
                dataIndex: "kode_anggran" + item["tahun"],
                key: "rekcode" + item["tahun"] + "1",
                align: "center",
                className: "hide th" + item["tahun"] + "rekap kolom",
                scopedSlots: { customRender: "dtlitemcode" },
              },
              {
                title: "Unit",
                width: 50,
                dataIndex: "jumlah" + item["tahun"],
                key: "rekjumlah" + item["tahun"] + "1",
                align: "right",
                className: "hide th" + item["tahun"] + "rekap kolom",
                //scopedSlots: { customRender: ('dtlitem01') }
              },
              {
                title: "unit price",
                width: 150,
                dataIndex: "harga_satuan" + item["tahun"],
                key: "rekharga_satuan" + item["tahun"] + "1",
                align: "right",
                className: "hide th" + item["tahun"] + "rekap kolom",
                scopedSlots: { customRender: "dtlitemprice" },
              },
              {
                title: "Sub Total",
                dataIndex: "rekap" + item["tahun"],
                key: "rekrekap" + item["tahun"],
                align: "right",
                width: 150,
                className: "hide th" + item["tahun"] + "rekap kolom",
                scopedSlots: { customRender: "dtlitemrekap" },
              },
              {
                title: "",
                dataIndex: "",
                key: "relative",
                align: "right",
                className: "hide th" + item["tahun"] + "rekap kolom",
              },
            ],
          };
          //push ke variable generate top root
          gencolm[1].children.push(dtljson2);
          gencolm[1].children.push(dtljson);
          lop++;
        });
  
        //rekap allrange tahun
        var rkpjson = {
          slots: { title: "customTitleTahun" },
          scopedSlots: { customRender: "tahun" },
          className: "unhide alltahun",
          children: [
            {
              title: "Grand Total",
              dataIndex: "rekapalltahun",
              key: "rekapalltahun",
              align: "right",
              float: "left",
              width: 150,
              className: "relative",
              scopedSlots: { customRender: "dtlitemrekap" },
            },
            {
              title: "",
              dataIndex: "",
              key: "rekaprelative",
              align: "right",
              className: "relative",
            },
          ],
        };
        gencolm[1].children.push(rkpjson);
  
        // var rkpjson3 = {
        //     title: '' ,
        //     className: "relative",
        //     children: [
        //       {
        //         title: '',
        //         dataIndex: '',
        //         key: 'relative',
        //         align: 'right',
        //         float: "left",
        //         className: "relative",
        //       },
        //     ],
        //   };
        // gencolm[1].children.push(rkpjson3);
  
        this.listThn.dtl = rangethn;
        this.listThn.rekap = rangethn;
        this.genColumn = gencolm;
      },
      btnExport(table, name) {
        console.log('clicked');
        
        this.data2.header[0].available = true;
        this.headerTitle = this.data2.header;
  
        let jns_anggaran = this.headerTitle[0].jenis_anggaran;
  
        this.headerTitle[0].jenis_anggaran = "";
        this.headerTitle[0].jenis_anggaran = jns_anggaran;
  
        // setTimeout(() => { this.data2.tree}, 3000);
        setTimeout(() => {
          let uri = "data:application/vnd.ms-excel;base64,",
            template =
              '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/><style>td {border:thin solid black;};table {border-collapse:collapse}</style></head><body><table>{table}</table></body></html>',
            base64 = function (s) {
              return window.btoa(unescape(encodeURIComponent(s)));
            },
            format = function (s, c) {
              return s.replace(/{(\w+)}/g, function (m, p) {
                return c[p];
              });
            };
          if (!table.nodeType)
            table = document.getElementsByClassName("ant-table-scroll");
          let h = document.getElementsByClassName("ant-table-title");
          let ctx = {
            worksheet: name || "Worksheet",
            table: h[0].innerHTML + table[1].innerHTML,
          };
          let a = document.createElement("a");
          a.href = uri + base64(format(template, ctx));
          a.download = "Budget.xls";
          a.click();
  
          this.$router.go();
        }, 3000);
      },
      async getbidang(){
        await axios({
            method: "get",
            url: this.$serviceUrl + "user/user_access",
            params: {
                tlc: this.getAuth.username
            },
            auth: {
                username: this.getAuth.username,
                password: this.getAuth.password
            },
            headers: {
                'X-API-KEY': this.getAuth.apikey
            }
        }).then(response => {
            for (let i1 = 0; i1 < response.data.data[0].nama_bidang.length; i1++) {
              if(response.data.data[0].nama_bidang[i1].toLowerCase() == 'financial control' && this.data2.header[0].sts_close!='1'){
                this.allowtoEdit = true; 
              }
            }
        }).catch(err => {
            return err
        });
      },
      handleCloseTrans(){
        const that = this;
        this.$confirm({
          title: "Are you sure to Close this Budget?",
          content: "",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            that.loading_close = true;
  
            let data = new FormData();
            data.append("anggaran_id", that.id);
            that.asyncAxiosPost("anggaran/close", "formdata", that.getAuth, data)
            .then((response) => {
              console.log(response)
              that.displayMessageValue("success-other", response.message);
              that.loading_close = false;
  
              that.$router.go(0);
            })
            .catch((err) => {
              that.loading_close = false;
              let response = Object.assign({}, err.response);
              if (response.data.status == false && response.data.message) {
                that.displayMessageValue("error-other", response.data.message);
              } else {
                let responses = Object.assign({}, err.response.data);
                that.displayMessageValue("error", responses);
              }
            });
          },
          onCancel() { },
        });
      },

      async onChangePeruntukan(e, val){
        this.id_update = val.peruntukan_id
        this.loading_update = true
        const item = this.data2.direktorat.find((d) => d.id_direktorat == e)

        const payload = {
          anggaran_id: this.data2.header[0].anggaran_id,
          peruntukan_id: val.peruntukan_id,
          id_direktorat: e,
          nama_direktorat: item.nama_direktorat
        }

        try {
          const response = await this.asyncAxiosPost(
            "anggaran/direktorat_peruntukan",
            "json",
            this.getAuth,
            payload
          )

          if(response){
            this.displayMessage("success-save")
          }
          this.loading_update = false 
        } catch (error) {
          console.log(error);
          this.loading_update = false 
          this.displayMessageValue("error", "Internal Server Error");
        }
      },

      async handleSubmitManifest(){
        this.loading_submit = true
        this.form.validateFields( async (err, values) => {
          console.log(values);
          if(err){
            this.displayMessage("form-warning");
            this.loading_submit = false
            return
          }
          
          try {
            const payload = {
              anggaran_id: this.data2.header[0].anggaran_id,
              status: values.action,
              remark: values.catatan? values.catatan : ''
            }
            const response = await this.asyncAxiosPost("anggaran/approval", "json", this.getAuth, payload)
            if(response){
              this.switchFetchManifest();
              this.displayMessage("success-save")

              if(response.last_respon){
                this.$router.push({
                  name: 'anggaran.manifestAcc',
                  params: {
                    id: this.id,
                    rabview: this.rabview,
                    budget_thn: this.budget_thn,
                    status: values.action
                  }
                })
              }
            }
            this.loading_submit = false
          } catch (error) {
            this.loading_submit = false
            console.log(error);
          }

        })
      },

      toManifestDraft(id){
        this.$router.push({
          name: 'anggaran.manifest.draft',
          params: {
            id: id
          }
        })
      },

      async onChangeTypePlafon(val){
        this.loading_update = true

        const payload = {
          anggaran_id: this.data2.header[0].anggaran_id,
          type_plafon: val
        }

        try {
          const response = await this.asyncAxiosPost(
            "anggaran/type_plafon",
            "json",
            this.getAuth,
            payload
          )

          if(response){
            this.displayMessage("success-save")
          }
          this.loading_update = false 
        } catch (error) {
          console.log(error);
          this.loading_update = false 
          this.displayMessageValue("error", "Internal Server Error");
        }
      },

      handleEdit(id){
        this.$router.push({
          name: 'aanggaranEditAcc',
          params: {
            id: id
          }
        })
      },

      toPage(name){
        router.push({
          name: name,
          id: this.data2.anggaran_id
        })
      }
    },

    updated() {
      //this.$nextTick(() => {
      if (this.$route.query && this.$route.query.xc) {
        let tempId = this.$route.query.xc.split(";")
        let Ids = "this.data2.tree[0]"
        for (let i = 0; i < tempId.length; i++) {
            Ids += ".children[" + tempId[i] + "]"
        }
        let el = document.querySelectorAll('[data-row-key="'+ eval(Ids + ".key") +'"]');
        for (let i = 0; i < el.length; i++) {
          el[i].style ="background: rgba(231, 76, 60, 0.25) !important;animation: myAnim 1s linear 0s 1 normal both;";
        }
        if(el[0])
          el[0].scrollIntoView({
            behavior: 'instant',
            block: 'center',
            inline: 'center'
          });
        }
      //}) // increase to ur needs
    },
    mounted() {
      this.toggleBodyClass("removeClass", "scrollDisable");
      Event.$on("refresh", this.switchFetchManifest);
      Event.$on("confirmMessageDelete", this.delete);
      Event.$on("confirmMessageClose", this.close);
      Event.$on("confirmMessageReturn", this.handleNewProcess);
      Event.$on("confirmMessageDelete", this.executeRemoveLampiran);
    },
    beforeDestroy() {
      this.toggleBodyClass("removeClass", "scrollDisable");
      Event.$off("refresh", this.switchFetchManifest);
      Event.$off("confirmMessageDelete", this.delete);
      Event.$off("confirmMessageClose", this.close);
      Event.$off("confirmMessageReturn", this.handleNewProcess);
      Event.$off("confirmMessageDelete", this.executeRemoveLampiran);
    },
  };

  </script>
  
  <style lang="less">
  .ant {
    &-modal {
      top: 12px !important;
    }
    &-table {
      &-footer {
        padding: 0;
      }
    }
    &-list-item {
      &-content {
        margin-bottom: 0 !important;
      }
    }
  }
  .m-price-total {
    margin: 0 !important;
    text-align: right;
  
    &.mobile {
      .ant-statistic-content {
        font-size: 14px;
        font-weight: 600;
      }
    }
  }
  .textbold {
    font-weight: bold;
  }
  
  @keyframes myAnim {
      0%,
      50%,
      100% {
          opacity: 1;
      }
  
      25%,
      75% {
          opacity: 0;
      }
  }

  .text-bold {
    font-weight: bold;
  }

  .margin-1 {
    margin-left: 10px;
  }

  .margin-2 {
    margin-left: 20px;
  }

  .margin-item {
    margin-left: 30px;
  }

  </style>
  